
import React from 'react';

// Components

import Tooltip from '../../common/tooltip/Tooltip';

// Constants

import { configs } from '../../../constants/configs/configs';


const ImmigrationStatusTooltip = props => {

    const {
        isState
    } = props;

    return (
        <Tooltip
            { ...{
                id: 'ssap.start.get_ready.item.floater_anchor',
                linkDomId: 'immigration_status',
                dataAutomationId: 'immigration_status',
                content: 'ssap.start.get_ready.item.floater_content',
                href: isState.NV ? configs.externalEndpoints.NV_LINKS.IMMIGRATION_STATUS_LINK : null,
                index: 'immigration_status',
                triggerDecorationClassName: isState.NV ? 'border-none' : 'tooltip-base'
            }  }
        />
    );
};

export default ImmigrationStatusTooltip;
